export const UserActionType = Object.freeze({
    LinkClick:   "link_click",
    PageView:  "page_view",
    ButtonClick: "button_click",
    FormSubmit: "form_submit",
    Scroll: "scroll",
    Click: "click",
    Conversion: "conversion"
});

export const UserPredictionType = Object.freeze({
    "low": 0,
    "medium": 1,
    "high": 2,
    "conversion": 3,
    "bot": 4
});

export class UserPush
{
    eventName =  "ai_event";
    userId = null;
    userActionType = null; 
    userActionTimestamp = null; 
    userActionTimestampNumeric = null;  

    fcUserSource = null;
    fcUserCampaign = null;
    fcUserMedium = null;
    fcUserTimestamp = null;

    userType = null;
    weightedDecile = 1;
    rgDecile = 1;
    clDecile = 1;
    fcDecile = 1;
    stDecile = 1;
    sgDecile = 1;
    clstrDecile = 1;
    whisperingType = 0;
}

export class UserAction
{
    id = null;
    userActionType = null;
    targetId = null;
    targetName = null;
    targetCss = null;
    targetValue = null;
    timestamp = null;
    timestampNumeric = null;
    href = null;
    scrollPosition = 0;
    conversionValue = 0;
}

export class UserState
{
    userId = null;
    domain = null;

    userType = "low";
    weightedDecile = 1;
    rgDecile = 1;
    clDecile = 1;
    fcDecile = 1;
    stDecile = 1;
    sgDecile = 1;
    clstrDecile = 1;
    whisperingType = 0;

    fcSource = null;
    fcCampaign = null;
    fcMedium = null;
    fcTimestamp = null;
    fcTimestampNumeric = null;
    fcSessionWeightedDecile = 1;
    fcSessionUserType = "low";
    fcSessionId = null;

    userBrowserType = null;
    isBot = null;
    isConversion = false;
    isDataLayerInitialized = false;
    
    currentSessionTimestamp = null;
    lastSessionTimestamp = null;
    lastConversionTimestamp = null;
    lastPredictionTimestamp = null;
    lastActionTimestamp = null;

    previousWeightedDecile = 1;
    previousRgDecile = 1;
    previousClDecile = 1;
    previousStDecile = 1;
    previousSgDecile = 1;
    previousClstrDecile = 1;
    previousWhisperingType = 0;
    previousUserType = "low";
    conversionCount = 0;
}

export class UserSession
{
    id = null;
    source = null;
    medium = null;
    campaign = null;
    timestamp = null;
    timestampNumeric = null;
}

export class UserActionPageData
{
    href = null;
    clicksCount = 0;
    scroll = 0;
}

export class UserActionAnalytics
{
    id = null;
    userActionType = null;

    href = null;
    scrollPosition = null;
    conversionValue = null;

    lastSessionTimestamp = null;

    sessionId = null;
    sessionFcSource = null;
    sessionFcMedium = null;
    sessionFcCampaign = null;

    signalUrl = null;
    signalType = null;

    userId = null;
    domain = null;

    conversionCount = null;

    previousWeightedDecile = null;
    previousRgDecile = null;
    previousClDecile = null;
    previousStDecile = null;
    previousSgDecile = null;
    previousClstrDecile = null;
    previousUserType = null;
    previousWhisperingType = null;

    nextUserType = null;
    nextWeightedDecile = null;
    nextRgDecile = null;
    nextStDecile = null;
    nextClDecile = null;
    nextSgDecile = null;
    nextClstrDecile = null;
    nextWhisperingType = null;
    
    fcDecile = null;

    fcSource = null;
    fcCampaign = null;
    fcMedium = null;
    fcSessionWeightedDecile = null;
    fcSessionUserType = null;
    fcSessionId = null;
    fcTimestamp = null;

    userBrowserType = null;
    isBot = null;
    isConversion = null;
    lastConversionTimestamp = null;
    lastPredictionTimestamp = null;
}

export class UserPrediction
{
    id = null;
    userActionType = null;

    rgDecile = null;
    clDecile = null;
    stDecile = null;
    sgDecile = null;
    clstrDecile = null;
    weightedDecile = null;
    whisperingType = null;
}

